import React from 'react';
import LazyLoader from '@loadable/component';
import {
    URL_DASHBOARD,
    URL_USER,
    URL_PRIEST_USER,
    URL_SUB_ADMIN,
    // URL_BANNER,
    URL_POST,
    URL_TEMPLE,
    URL_TEMPLE_SLOT,
    URL_FOOD_CATEGORY,
    URL_FOOD_ITEM,
    URL_PRODUCT_CATEGORY,
    URL_PRODUCT_ITEM,
    URL_CHANGE_PASSWORD,
    URL_STATIC_PAGE,
    URL_PROFILE,
    URL_COMMISSION,
    URL_PROMO_CODE,
    URL_FOOD_RESTAURANT_RANGE,
    SATVIK_FOOD_ORDER,
    EMAIL_TEMPLATES,
    PAYOUT_REQUESTS,
    CONTACT_US_FORM_DATA,
    URL_PRIEST_USER_REQUEST,
    URL_BLOCKED_USER,
    URL_REPORTED_POST,
    URL_NORMAL_USER_POST,
    URL_REPORTED_COMMENTS,
    URL_REPORTED_PROFILE,
    URL_TEMPLE_SLOT_VIEW,
    URL_DHAM_MANAGEMENT,
    URL_VISIT_MANAGEMENT,
    URL_ITINERY_MANAGEMENT,
    URL_HOTELS_MANAGEMENT,
    URL_TAXI_TRANSFER,
    URL_BOOK_RIDE,
    URL_GUIDE_MANAGEMENT,
    URL_RIDE_MANAGEMENT,
    URL_ACTIVITIES_MANAGEMENT,
    URL_DRIVERS,
    URL_DHAM_MANAGEMENT_REQUESTS,
    URL_BOOK_GUIDE,
    URL_DRIVER_USER_REQUEST,
    URL_GUIDE_USER_REQUEST,
    URL_TEMPLE_MANAGEMENT,
    URL_POOJA_MANAGEMENT,
    URL_SHOP_RANGE,
    PRASADAM_ORDER,
    REQUESTS_FOR_PAYOUT,
    URL_KATHAKAR,
    URL_KATHA,
    URL_PUJARI,
    URL_POOJA_CEREMONY,
    URL_POOJA_PACKAGE,
    URL_BOOKINGS_KATHA_POOJA,
    URL_VENDOR_USER,
    DIVINE_SHOP_ORDER,
    URL_RESTAURANT,
    URL_TEMPLE_SLOT_BOOKINGS,
    URL_REPORTS,
    COMMUNITY_USERS
} from 'Helpers/Paths';

// Error boundary component for lazy loaded components
const ErrorFallback = ({ error }) => (
    <div
        style={{
            padding: '20px',
            textAlign: 'center',
            color: '#d32f2f'
        }}>
        <h2>Something went wrong</h2>
        <p>{error.message}</p>
    </div>
);

// Enhanced lazy loading wrapper (no route-level loading UI while chunks load)
const lazyLoad = (importFn) => {
    return LazyLoader(importFn, {
        fallback: null,
        ErrorBoundary: ErrorFallback
    });
};

const RoutesArray = [
    {
        path: URL_DASHBOARD,
        exact: true,
        component: lazyLoad(() => import('Components/Dashboard/Dashboard'))
    },
    {
        path: URL_REPORTS,
        exact: true,
        component: lazyLoad(() => import('Components/Reports/Reports'))
    },
    {
        path: URL_USER,
        exact: true,
        component: lazyLoad(() => import('Components/User/DevoteeUser'))
    },
    {
        path: EMAIL_TEMPLATES,
        exact: true,
        component: lazyLoad(() => import('Components/Email Templates/EmailTemplates'))
    },
    {
        path: PAYOUT_REQUESTS,
        exact: true,
        component: lazyLoad(() => import('Components/Request/PayoutRequest'))
    },
    {
        path: REQUESTS_FOR_PAYOUT,
        exact: true,
        component: lazyLoad(() => import('Components/Request/RequestsForPayout'))
    },
    {
        path: CONTACT_US_FORM_DATA,
        exact: true,
        component: lazyLoad(() => import('Components/ContactUs/ContactUs'))
    },
    {
        path: SATVIK_FOOD_ORDER,
        exact: true,
        component: lazyLoad(() => import('Components/Orders/SatvikFoodOrders'))
    },
    {
        path: DIVINE_SHOP_ORDER,
        exact: true,
        component: lazyLoad(() => import('Components/Orders/DivineShopOrders'))
    },
    {
        path: PRASADAM_ORDER,
        exact: true,
        component: lazyLoad(() => import('Components/Orders/PrasadamOrders'))
    },
    {
        path: URL_PRIEST_USER,
        exact: true,
        component: lazyLoad(() => import('Components/User/PriestUser'))
    },
    {
        path: URL_PRIEST_USER_REQUEST,
        exact: true,
        component: lazyLoad(() => import('Components/User/PriestUserRequest'))
    },
    {
        path: URL_DRIVER_USER_REQUEST,
        exact: true,
        component: lazyLoad(() => import('Components/User/DriverUserRequest'))
    },
    {
        path: URL_GUIDE_USER_REQUEST,
        exact: true,
        component: lazyLoad(() => import('Components/User/GuideUserRequest'))
    },
    {
        path: URL_SUB_ADMIN,
        exact: true,
        component: lazyLoad(() => import('Components/SubAdmin/SubAdmin'))
    },
    // {
    //     path: URL_BANNER,
    //     exact: true,
    //     component: LazyLoader(() => import('Components/Banners/Banners'))
    // },
    {
        path: URL_POST,
        exact: true,
        component: lazyLoad(() => import('Components/Post/Post'))
    },
    {
        path: URL_TEMPLE,
        exact: true,
        component: lazyLoad(() => import('Components/Temple/Temple'))
    },
    {
        path: URL_TEMPLE_SLOT_BOOKINGS,
        exact: true,
        component: lazyLoad(() => import('Components/Temple/SlotBookings'))
    },
    {
        path: URL_TEMPLE_SLOT,
        exact: true,
        component: lazyLoad(() => import('Components/Temple/Slots'))
    },
    {
        path: URL_TEMPLE_SLOT_VIEW,
        exact: true,
        component: lazyLoad(() => import('Components/Temple/ViewSlot'))
    },
    {
        path: URL_FOOD_CATEGORY,
        exact: true,
        component: lazyLoad(() => import('Components/Food/FoodCategory'))
    },
    {
        path: URL_FOOD_ITEM,
        exact: true,
        component: lazyLoad(() => import('Components/Food/FoodItem'))
    },
    {
        path: URL_RESTAURANT,
        exact: true,
        component: lazyLoad(() => import('Components/Food/Restaurant'))
    },
    {
        path: URL_FOOD_RESTAURANT_RANGE,
        exact: true,
        component: lazyLoad(() => import('Components/Food/FoodRestaurantRange'))
    },
    {
        path: URL_PRODUCT_CATEGORY,
        exact: true,
        component: lazyLoad(() => import('Components/DivineShop/Category'))
    },
    {
        path: URL_PRODUCT_ITEM,
        exact: true,
        component: lazyLoad(() => import('Components/DivineShop/Product'))
    },
    {
        path: URL_CHANGE_PASSWORD,
        exact: true,
        component: lazyLoad(() => import('Components/ChangePassword/ChangePassword'))
    },
    {
        path: URL_STATIC_PAGE,
        exact: true,
        component: lazyLoad(() => import('Components/StaticPages/StaticPages'))
    },
    {
        path: URL_PROFILE,
        exact: true,
        component: lazyLoad(() => import('Components/Profile/Profile'))
    },
    {
        path: URL_COMMISSION,
        exact: true,
        component: lazyLoad(() => import('Components/Commission/Commission'))
    },
    {
        path: URL_PROMO_CODE,
        exact: true,
        component: lazyLoad(() => import('Components/PromoCode/PromoCode'))
    },
    {
        path: URL_BLOCKED_USER,
        exact: true,
        component: lazyLoad(() => import('Components/Community/BlockedUser'))
    },
    {
        path: URL_REPORTED_POST,
        exact: true,
        component: lazyLoad(() => import('Components/Community/ReportedPost'))
    },
    {
        path: COMMUNITY_USERS,
        exact: true,
        component: lazyLoad(() => import('Components/Community/CommunityUsers'))
    },
    {
        path: URL_NORMAL_USER_POST,
        exact: true,
        component: lazyLoad(() => import('Components/Community/NormalUserPost'))
    },
    {
        path: URL_REPORTED_COMMENTS,
        exact: true,
        component: lazyLoad(() => import('Components/Community/ReportedComments'))
    },
    {
        path: URL_REPORTED_PROFILE,
        exact: true,
        component: lazyLoad(() => import('Components/Community/ReportedProfile'))
    },
    {
        path: URL_DHAM_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/DhamManagement'))
    },
    {
        path: URL_DHAM_MANAGEMENT_REQUESTS,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/Requests'))
    },
    {
        path: URL_VISIT_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/VisitManagement'))
    },
    {
        path: URL_ITINERY_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/ItineryManagement'))
    },
    {
        path: URL_HOTELS_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/HotelManagement'))
    },
    {
        path: URL_TAXI_TRANSFER,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/TaxiTransfer'))
    },
    {
        path: URL_BOOK_RIDE,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/BookRide'))
    },
    {
        path: URL_BOOK_GUIDE,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/BookGuide'))
    },
    {
        path: URL_DRIVERS,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/Drivers'))
    },
    {
        path: URL_GUIDE_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/GuideManagement'))
    },
    {
        path: URL_RIDE_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/BookRide'))
    },
    {
        path: URL_ACTIVITIES_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/DhamYatra/ActivitiesManagement'))
    },
    {
        path: URL_TEMPLE_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/PrasadamBooking/TempleManagement'))
    },
    {
        path: URL_POOJA_MANAGEMENT,
        exact: true,
        component: lazyLoad(() => import('Components/PrasadamBooking/PoojaManagement'))
    },
    {
        path: URL_SHOP_RANGE,
        exact: true,
        component: lazyLoad(() => import('Components/PrasadamBooking/TempleRange'))
    },
    {
        path: URL_KATHAKAR,
        exact: true,
        component: lazyLoad(() => import('Components/User/Kathakar'))
    },
    {
        path: URL_KATHA,
        exact: true,
        component: lazyLoad(() => import('Components/KathaManagement/Kathas'))
    },
    {
        path: URL_PUJARI,
        exact: true,
        component: lazyLoad(() => import('Components/User/Pujari'))
    },
    {
        path: URL_POOJA_CEREMONY,
        exact: true,
        component: lazyLoad(() => import('Components/KathaManagement/PoojaCeremony'))
    },
    {
        path: URL_POOJA_PACKAGE,
        exact: true,
        component: lazyLoad(() => import('Components/KathaManagement/PoojaPackage'))
    },
    {
        path: URL_BOOKINGS_KATHA_POOJA,
        exact: true,
        component: lazyLoad(() => import('Components/KathaManagement/Requests'))
    },
    {
        path: URL_VENDOR_USER,
        exact: true,
        component: lazyLoad(() => import('Components/User/VendorUser'))
    }
];

/**
 * Preload lazy route chunks in background to reduce blank/blink on first sidebar navigation.
 * Safe to call multiple times; loadable caches resolved chunks.
 */
export const preloadAllRouteChunks = () => {
    RoutesArray.forEach((route) => {
        route?.component?.preload?.();
    });
};

export default RoutesArray;
